import React from 'react'
import PropTypes from 'prop-types'
import Headings from '../Headings'
import { StyledCard } from './styles'

const Card = ({ title, children }) => {
  return (
    <StyledCard tabIndex="0">
      <Headings level="h3" text={title}></Headings>
      {children}
    </StyledCard>
  )
}

Card.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
}

export default Card
